// Angular
import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { ProgressBarModule } from '@syncfusion/ej2-angular-progressbar';
// Components
import { BaseComponent } from './components/theme/base/base.component';
import { ErrorPageComponent } from './components/theme/content/error-page/error-page.component';
import { AuthGuard } from './Services/auth.guard';
import { RedirectComponent } from './components/partials/content/shared/redirect/redirect.component';
import { PrintComponent } from './components/print/print.component';
import { WebOPACComponent } from './components/webOPAC/webOPAC.component';


import { StudentListv2Component } from './components/pages/student-listv2/student-listv2.component';
import { Communicationv2Component } from './components/pages/communicationv2/communicationv2.component';
import { Admissionv2Component } from './components/pages/admissionv2/admissionv2.component';

const routes: Routes = [
	{
		path: 'printGlobal',
		loadChildren: () => import('./components/printGlobal/printReceipt.module').then(m => m.PrintReceiptModule)
	},
	{path: 'digital', loadChildren: () => import('./components/displayNotice/displayNotice.module').then(m => m.DisplayNoticeModule)},
	{path: 'auth', loadChildren: () => import('./components/pages/auth/auth.module').then(m => m.AuthModule)},
	// {
	// 	path: 'webOPAC',
	// 	component: WebOPACComponent,
	// 	canActivate: [AuthGuard],
	// 	children: [
	// 		{path: '', loadChildren: () => import('./components/webOPAC/webOPAC.module').then(m => m.WebOPACModule)},
	// 	]
	// },
	{path: 'webOPAC', loadChildren: () => import('./components/webOPAC/webOPAC.module').then(m => m.WebOPACModule)},
	{
				path: 'verifyDocument',
				loadChildren: () => import('./components/pages/verifyDocument/verifyDocument.module').then(m => m.VerifyDocument)
	},
	{
		path: 'print',
		loadChildren: () => import('./components/print/print.module').then(m => m.PrintModule),
		canActivate: [AuthGuard]
	},

	{
		path: '',
		component: BaseComponent,
		canActivate: [AuthGuard],
		children: [

			{
				path: 'dashboard',
				loadChildren: () => import('./components/pages/dashboard/dashboard.module').then(m => m.DashboardModule)
			},
			{
				path: 'superAdmin',
				loadChildren: () => import('./components/pages/superAdmin/superAdmin.module').then(m => m.SuperAdminModule)
			},
			{
				path: 'entity',
				loadChildren: () => import('./components/pages/entityDashboard/entityDashboard.module').then(m => m.EntityDashboardModule)
			},
			{
				path: 'analytics',
				loadChildren: () => import('./components/pages/analytics/analytics.module').then(m => m.AnalyticsModule)
			},
			{
				path: 'fee',
				loadChildren: () => import('./components/pages/fee/fee.module').then(m => m.FeeModule)
			},
			{
				path: 'attendance',
				loadChildren: () => import('./components/pages/attendance/attendance.module').then(m => m.AttendanceModule)
			},
			{
				path: 'attendanceNew',
				loadChildren: () => import('./components/pages/attendanceNew/attendance.module').then(m => m.AttendanceNewModule)
			},
			{
				path: 'feeSetup',
				loadChildren: () => import('./components/pages/feeStructure/feeStructure.module').then(m => m.FeeStructureModule)
			},
			{
				path: 'schoolSetup',
				loadChildren: () => import('./components/pages/schoolSetup/schoolSetup-routing.module').then(m => m.SchoolSetupRoutingModule)
			},
			{
				path: 'integration',
				loadChildren: () => import('./components/pages/integrationMaster/integrationMaster.module').then(m => m.IntegrationMasterModule)
			},
			{
				path: 'transport',
				loadChildren: () => import('./components/pages/transport/transport.module').then(m => m.TransportModule)
			},
			{
				path: 'student',
				loadChildren: () => import('./components/pages/studentList/studentList.module').then(m => m.StudentListModule)
			},
			{
				path: 'studentListv2',
				component: StudentListv2Component
			},
			{
				path: 'users',
				loadChildren: () => import('./components/pages/users/users.module').then(m => m.UsersModule)
			},
			{
				path: 'taskManagement',
				loadChildren: () => import('./components/pages/taskManagement/taskManagement.module').then(m => m.TaskManagementModule)
			},
			{
				path: 'accountingSetup',
				loadChildren: () => import('./components/pages/accountingMasterSetup/accountingMaster.module').then(m => m.AccountingMasterModule)
			},
			{
				path: 'accounting',
				loadChildren: () => import('./components/pages/accounting/accounting.module').then(m => m.AccountingModule)
			},
			{
				path: 'studentDashboard',
				loadChildren: () => import('./components/pages/studentDashboard/studentDashboard.module').then(m => m.StudentDashboardModule)
			},
			{
				path: 'sharePoint',
				loadChildren: () => import('./components/pages/sharePoint/sharePoint.module').then(m => m.SharePointModule)
			},
			{
				path: 'gallery',
				loadChildren: () => import('./components/pages/gallery/gallery.module').then(m => m.GalleryModule)
			},
			{
				path:'lessonManagement',
				loadChildren: () => import('./components/pages/LessonPlanCrud/lessonPlanCrud.module').then(m => m.LessonPlanModule)
			},
			{
				path: 'academicsSetup',
				loadChildren: () => import('./components/pages/academicsSetup/academicsSetup.module').then(m => m.AcademicsSetupModule)
			},
			{
				path: 'socialMedia',
				loadChildren: () => import('./components/pages/socialMedia/socialMedia.module').then(m => m.SocialMediaModule)
			},
			{
				path: 'naacMaster',
				loadChildren: () => import('./components/pages/naacMaster/naacMaster.module').then(m =>m.NaacMasterModule)
			},
			{
				path: 'naac',
				loadChildren: () => import('./components/pages/naac/naac.module').then(m => m.NaacModule)
			},
			{
				path:'profilePortal',
				loadChildren:()=>import('./components/pages/employee-portal/employeePortal.module').then(m=>m.EmployeePortalModule)
			},
			{
				path: 'hrm',
				loadChildren: () => import('./components/pages/hrm/hrm.module').then(m => m.HRMModule)
			},
			{
				path: 'advancedSetup',
				loadChildren: () => import('./components/pages/advanced/advanced.module').then(m => m.AdvancedModule)
			},
			{
				path: 'admission',
				loadChildren: () => import('./components/pages/admission/admission.module').then(m => m.AdmissionModule)
			},
			{
				path: 'admissionv2',
				component: Admissionv2Component
			},
			{
				path: 'library',
				loadChildren: () => import('./components/pages/library/library.module').then(m => m.LibraryModule)
			},
			{
				path: 'communication',
				loadChildren: () => import('./components/pages/communication/communication.module').then(m => m.CommunicationModule)
			},
			{
				path: 'communicationv2',
				component: Communicationv2Component
			},
			{
				path: 'schoolDiary',
				loadChildren: () => import('./components/pages/schoolDiary/schoolDiary.module').then(m => m.SchoolDiaryModule)
			},
			{
				path: 'examination',
				loadChildren: () => import('./components/pages/examination/examination.module').then(m => m.ExaminationModule)
			},
			{
				path: 'insights',
				loadChildren: () => import('./components/pages/insights/insights.module').then(m => m.InsightsModule)
			},
			{
				path: 'transportAttendance',
				loadChildren: () => import('./components/pages/transportAttendance/transportAttendance.module').then(m => m.TransportAttendanceModule)
			},
			{
				path: 'hostelAttendance',
				loadChildren: () => import('./components/pages/hostelAttendance/hostelAttendance.module').then(m => m.HostelAttendanceModule)
			},
			{
				path:'learningManagement',
				loadChildren:()=> import('./components/pages/learningManagement/learningManagement.module').then(m=>m.LearningManagementModule)
			},
			{
				path: 'reportFile',
				loadChildren: () => import('./components/pages/reportFile/reportFile.module').then(m => m.ReportFileModule)
			},
			{
				path: 'frontDesk',
				loadChildren: () => import('./components/pages/frontDesk/frontDesk.module').then(m => m.FrontDeskModule)
			},
			{
				path: 'questionPaper',
				loadChildren: () => import('./components/pages/questionPaper/questionPaper.module').then(m => m.QuestionPaperModule)
			},
			{
				path: 'expenseManagement',
				loadChildren: () => import('./components/pages/expenseManagement/expenseManagement.module').then(m => m.ExpenseManagementModule)
			},
			{
				path: 'attendanceV3',
				loadChildren: () => import('./components/pages/attendanceV3/attendanceV3.module').then(m => m.AttendanceV3Module)
			},
			{
				path: 'cms',
				loadChildren: () => import('./components/pages/cms/cms.module').then(m => m.CmsModule)
			},
			{
				path: 'workflow',
				loadChildren: () => import('./components/pages/workflow/workflow.module').then(m => m.WorkflowModule)
			},
			{
				path: 'studentQueries',
				loadChildren: () => import('./components/pages/studentQueries/studentQueries.module').then(m => m.StudentQueries)
			},
			{
				path: 'builder',
				loadChildren: () => import('./components/theme/content/builder/builder.module').then(m => m.BuilderModule)
			},
			{
				path: 'capturePayment',
				loadChildren: () => import('./components/pages/capturePayment/capturePayment.module').then(m => m.CapturePaymentModule)
			},
			{
				path: 'feedbackFromStudent',
				loadChildren: () => import('./components/pages/feedbackFromStudent/feedbackFromStudent.module').then(m => m.FeedbackFromStudentModule)
			},
			{
				path: 'web-opac',
				loadChildren: () => import('./components/pages/web-opac/web-opac.module').then(m => m.WebOpacModule)
			},
			{
				path: 'messManagement',
				loadChildren: () => import('./components/pages/messManagement/messManagement.module').then(m => m.MessManagementModule)
			},
			{
				path: 'coe',
				loadChildren: () => import('./components/pages/coeExamination/coeExamination.module').then(m => m.CoeExaminationModule)
			},
			{
				path: 'chatBot',
				loadChildren: () => import('./components/pages/chat-bot/chat-bot.module').then(m => m.ChatBotModule)
			},
			{
				path: 'extraMarksLMS',
				loadChildren: () => import('./components/pages/lms/lms.module').then(m => m.LmsModule)
			},
			{
				path: 'utilities',
				loadChildren: () => import('./components/pages/utilities/utilities.module').then(m => m.UtilitiesModule)
			},
			{
				path: 'studentOverview',
				loadChildren: () => import('./components/pages/studentOverviewDashboard/studentOverviewDashboard.module').then(m => m.StudentOverviewDashboardModule)
			},

			{
				path: 'error/403',
				component: ErrorPageComponent,
				data: {
					type: 'error-v6',
					code: 403,
					title: '403... Access forbidden',
					desc: 'Looks like you don\'t have permission to access for requested page.<br> Please, contact administrator'
				}
			},
			{path: 'error/:type', component: ErrorPageComponent},
			{path: 'redirect', component: RedirectComponent},
			{path: '', redirectTo: 'redirect', pathMatch: 'full'},
			{path: '**', redirectTo: 'redirect', pathMatch: 'full'}
		]
	},

	// {path: '**', redirectTo: 'entity', pathMatch: 'full'},
];

@NgModule({
	imports: [
		RouterModule.forRoot(routes),
		ProgressBarModule
	],
	exports: [RouterModule]
})
export class AppRoutingModule {
}
